import React from "react";

import { useIntl } from "react-intl";

import CountryCode from "@mapmycustomers/shared/enum/CountryCode";
import { Labeled, SelectField } from "@mapmycustomers/ui";

import useCountryListOptions from "@app/util/countries/useCountryListOptions";

import styles from "./CountryField.module.scss";

interface Props {
  disabled?: boolean;
  onChange: (value?: CountryCode) => void;
}

const CountryField: React.FC<Props> = ({ disabled, onChange }) => {
  const intl = useIntl();
  const countryListOptions = useCountryListOptions(intl);

  return (
    <Labeled
      label={intl.formatMessage({
        id: "view.selectBar.button.bulkEdit.panel.selectCountry",
        defaultMessage: "Select country",
        description: "Bulk Edit country control label",
      })}
    >
      <SelectField
        className={styles.selector}
        disabled={disabled}
        dropdownMatchSelectWidth
        onChange={onChange}
        optionFilterProp="text"
        options={countryListOptions}
        placeholder={intl.formatMessage({
          id: "view.selectBar.button.bulkEdit.panel.selectCountry.placeholder",
          defaultMessage: "Country",
          description: "Bulk Edit country control placeholder",
        })}
        showSearch
      />
    </Labeled>
  );
};

export default CountryField;
